import { AxiosInstance } from 'axios';

import { axios } from '../../../../api/axios-instance';
import { wishlishEndpoints } from '../../../../constants';
import { IWishlistProduct } from '../../entities/wishlist-product';
import { AddToWishListInput } from '../../schemas/wishlist.schema';

class WishlistApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  getWishlishProducts = async (cartId: number): Promise<IWishlistProduct[]> =>
    this.#requestInstance.get(wishlishEndpoints.wishlishProductId(cartId));

  addToWishlist = async (input: AddToWishListInput): Promise<IWishlistProduct> =>
    this.#requestInstance.post(wishlishEndpoints.wishlishProduct, input);

  removeFromWishlist = async (wishlistProductId: number): Promise<void> =>
    this.#requestInstance.delete(wishlishEndpoints.wishlishProductId(wishlistProductId));
}

export const wishlistApi = new WishlistApi(axios);
